import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { QueryStatus, authAxios } from "../../utils";
import { RootState } from "../../redux/store";
import {
  CreateTankCapacityInput,
  GetSivDataByRegistrationNumberRequest,
  GetSivDataByRegistrationNumberResponse,
} from "./tankCapacitiesApi";

export interface DriverState {
  createTankCapacityStatus: QueryStatus;
  getSivDataByRegistrationNumberStatus: QueryStatus;
  sivData: GetSivDataByRegistrationNumberResponse | null;
}

const initialStateDriver: DriverState = {
  createTankCapacityStatus: "idle",
  getSivDataByRegistrationNumberStatus: "idle",
  sivData: null,
};

export const createTankCapacity = createAsyncThunk(
  "tankCapacities/create",
  async (payload: CreateTankCapacityInput) => {
    const axios = authAxios();
    await axios.post("/tank_capacity", payload);
  },
);

export const getSivDataByRegistrationNumber = createAsyncThunk(
  "tankCapacities/getSivData",
  async (payload: GetSivDataByRegistrationNumberRequest) => {
    const axios = authAxios();
    const response = await axios.get<GetSivDataByRegistrationNumberResponse>(
      "/vehicles/siv_data",
      { params: payload },
    );
    return response.data;
  },
);

export const tankCapacitiesSlice = createSlice({
  name: "tankCapacities",
  initialState: initialStateDriver,
  reducers: {
    resetGetSivDataStatus: (state) => {
      state.getSivDataByRegistrationNumberStatus = "idle";
      state.sivData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createTankCapacity.pending, (state) => {
        state.createTankCapacityStatus = "processing";
      })
      .addCase(createTankCapacity.fulfilled, (state) => {
        state.createTankCapacityStatus = "success";
      })
      .addCase(createTankCapacity.rejected, (state) => {
        state.createTankCapacityStatus = "failed";
      })
      .addCase(getSivDataByRegistrationNumber.pending, (state) => {
        state.getSivDataByRegistrationNumberStatus = "processing";
      })
      .addCase(getSivDataByRegistrationNumber.fulfilled, (state, action) => {
        state.getSivDataByRegistrationNumberStatus = "success";
        state.sivData = action.payload;
      })
      .addCase(getSivDataByRegistrationNumber.rejected, (state) => {
        state.getSivDataByRegistrationNumberStatus = "failed";
        state.sivData = null;
      });
  },
});

export const selectCreateTankCapacityStatus = (state: RootState) =>
  state.tankCapacities.createTankCapacityStatus;

export const selectGetSivDataByRegistrationNumberStatus = (state: RootState) =>
  state.tankCapacities.getSivDataByRegistrationNumberStatus;

export const selectSivData = (state: RootState) => state.tankCapacities.sivData;

export default tankCapacitiesSlice.reducer;
